import httpClient from '@/api/http-client';
import clone from 'just-clone';
import getFormData from '@/util/form-data';

const endpoint = 'api/driving-practice-exams';

const drivingPracticeExamService = {
  getPage: (params) => httpClient.get(endpoint, { params }),

  getById: (id) => httpClient.get(`${endpoint}/${id}`),

  search: (query) => httpClient.get(`${endpoint}/find/${query}`),

  create: (drivingPracticeExam) => {
    const newExam = clone(drivingPracticeExam);
    if (newExam.date) {
      newExam.date = `${newExam.date}:00`; // we need to add seconds for BE
    }
    return httpClient.post(`${endpoint}`, newExam);
  },

  update: (drivingPracticeExam) => {
    const newExam = clone(drivingPracticeExam);
    if (newExam.date) {
      // We need to check if seconds is attached to the string
      const timeParts = newExam.date.split(' ')[1].split(':');
      // If seconds are missing, add ":00" to the time
      if (timeParts.length === 2) {
        newExam.date = `${newExam.date}:00`;
      }
    }

    return httpClient.put(`${endpoint}/${newExam.id}`, newExam);
  },

  delete: (drivingPracticeExam) => httpClient.delete(`${endpoint}/${drivingPracticeExam.id}`),

  getAvailableDates: (airportId) =>
    httpClient.get(`api/driving-practice-exam-available-dates-by-airport/${airportId}`),

  getParticipants: (examId) => httpClient.get(`${endpoint}/${examId}/participants`),

  getParticipant: (participantId) =>
    httpClient.get(`api/driving-practice-exam-participants/${participantId}`),

  updateParticipant: (participant) => {
    const fieldBlacklist = ['instructor_user', 'participant_user', 'permit'];
    const formData = getFormData(participant, fieldBlacklist);
    formData.append('_method', 'put');
    if (participant.participant_signature) {
      formData.append('participant_signature', participant.participant_signature);
    }

    return httpClient.post(`api/driving-practice-exam-participants/${participant.id}`, formData);
  },

  getParticipationStatus: (payload) =>
    httpClient.get(
      `api/driving-practice-exam-participation-status/${payload.user_id}/${payload.airport_id}`,
      {
        params: {
          has_requested_ability_to_manoeuvre: payload.has_requested_ability_to_manoeuvre ? 1 : 0,
          permit_id: payload.permit_id ? payload.permit_id : null,
        },
      },
    ),
};

export default drivingPracticeExamService;
